import type { NextRouter } from 'next/router';

const getPathParamKeys = (pathname: string) =>
  new Set(
    [...pathname.matchAll(/\[(?:\.\.\.)?([^\]]+)]/g)].map((match) => match[1]),
  );

export const buildPaginationHref = (router: NextRouter, page: number) => {
  const [path] = router.asPath.split('?');
  const params = new URLSearchParams();
  const pathParamKeys = getPathParamKeys(router.pathname);

  Object.entries(router.query).forEach(([key, value]) => {
    if (value === undefined || pathParamKeys.has(key)) return;

    if (Array.isArray(value)) {
      value.forEach((entry) => params.append(key, entry));
      return;
    }

    params.set(key, value);
  });

  params.set('pageNumber', String(page));

  if (page <= 1) {
    params.delete('pageNumber');
  }

  const queryString = params.toString();
  return queryString ? `${path}?${queryString}` : path;
};
